export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-nl.28838e9a.png";